module.exports = __webpack_public_path__ + "img/logo-W.bded8ed5.png";